const sortArrayByMultipleCriteria = (items, sortingCriterias) => {
    items.sort((a, b) => {
        for (let i = 0; i < sortingCriterias.length; i += 1) {
            const sortingResult = sortingCriterias[i](a, b);

            // if sorting function already returns a change, no need to sort by further criteria
            if (sortingResult !== 0) {
                return sortingResult;
            }
        }

        return 0;
    });

    return items;
};

export { sortArrayByMultipleCriteria };
